export const MOBILE_MAX_WIDTH = 599;
export const TABLET_MAX_WIDTH = 899;
export const DESKTOP_MIN_WIDTH = 900;
